<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="400px">
      <v-card>
        <v-card-title class="justify-center">Factura</v-card-title>

        <v-divider></v-divider>
        <br />

        <v-card-text class="text-center">
          <v-spacer></v-spacer>

          <span>
            ¿Quiere Factura?
          </span>

          <v-spacer></v-spacer>

          <v-btn
            v-if="!loading"
            color="light"
            text
            style="margin-top: 25px; height: 50px; width: 50px; font-size: 50px"
            @click="pay(false)"
          >
            <font-awesome-icon
              icon="times-circle"
              :style="{ color: '#ea2222', fontSize: 50 }"
            />
          </v-btn>

          <v-btn
            v-if="!loading"
            color="light"
            text
            style="margin-top: 25px; height: 50px; width: 50px; font-size: 50px"
            @click="pay(true)"
          >
            <font-awesome-icon
              icon="check-circle"
              :style="{ color: '#11bd11', fontSize: 50 }"
            />
          </v-btn>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import firebaseMixin from "@/mixins/firebase/firebaseMixin";

export default {
  name: "CashPaymentDialog",
  mixins: [firebaseMixin],
  data() {
    return {
      dialog: false,
      loading: false,
      amount: 0,
      dividePayment: "",
      selectedProducts: [],
      payment: "",
      orders: []
    };
  },
  methods: {
    openDialog(amount, dividePayment, selectedProducts, payment) {
      console.log(amount, dividePayment, selectedProducts, payment);
      this.amount = amount;
      this.dividePayment = dividePayment;
      this.selectedProducts = selectedProducts;
      this.payment = payment;
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    pay(invoiceRequest) {
      this.$emit(invoiceRequest ? "payWithInvoice" : "payWithoutInvoice", {
        amount: this.amount,
        dividePayment: this.dividePayment,
        selectedProducts: this.selectedProducts,
        payment: this.payment,
        invoiceRequest: invoiceRequest
      });

      this.dialog = false;
    }
  }
};
</script>
